export default __webpack_public_path__ + "static/media/paper.93fc7a80.jpg";